// client/src/components/AnimeAvatar.jsx
import React from 'react';

const AnimeAvatar = ({ position, rarity = 'bronze', className = "w-24 h-24" }) => {
  // تحويل المركز إلى اسم الملف الأساسي (بدون ندرة)
  const getBaseName = () => {
    switch (position) {
      case 'Striker': return 'striker';
      case 'Defender': return 'defender';
      case 'Midfielder': return 'midfielder';
      case 'Goalkeeper': return 'goalkeeper';
      default: return 'player';
    }
  };

  // بناء مسار الصورة حسب الندرة
  const getImagePath = () => {
    const baseName = getBaseName();
    // البطاقات الذهبية والفضية والبرونزية: تستخدم صوراً مخصصة
    if (rarity === 'gold' || rarity === 'silver' || rarity === 'bronze') {
      return `/img/${rarity}_${baseName}.jpg`;
    }
    // البطاقات العادية (common): تعود إلى النظام القديم (striker.jpg, defender.jpg, ...)
    return `/img/${baseName}.jpg`;
  };

  // أنماط الإطار حسب الندرة
  const getRarityStyles = () => {
    switch (rarity) {
      case 'gold':
        return {
          wrapper: 'bg-gradient-to-br from-yellow-300 via-yellow-500 to-yellow-700',
          border: 'border-yellow-200',
          shadow: 'shadow-[0_0_20px_rgba(251,191,36,0.6)]',
          badgeBg: 'bg-yellow-900 text-yellow-100'
        };
      case 'silver':
        return {
          wrapper: 'bg-gradient-to-br from-gray-100 via-gray-400 to-gray-600',
          border: 'border-gray-100',
          shadow: 'shadow-[0_0_15px_rgba(156,163,175,0.4)]',
          badgeBg: 'bg-gray-800 text-gray-100'
        };
      case 'bronze':
        return {
          wrapper: 'bg-gradient-to-br from-orange-400 via-orange-700 to-orange-900',
          border: 'border-orange-500',
          shadow: 'shadow-[0_0_15px_rgba(124,45,18,0.4)]',
          badgeBg: 'bg-orange-950 text-orange-100'
        };
      default:
        return {
          wrapper: 'bg-gray-200',
          border: 'border-gray-300',
          shadow: '',
          badgeBg: 'bg-gray-600 text-white'
        };
    }
  };

  const styles = getRarityStyles();

  return (
    <div className={`relative inline-block p-1 rounded-2xl border-2 ${styles.wrapper} ${styles.border} ${styles.shadow} transition-transform hover:scale-105`}>
      <img
        src={getImagePath()}
        alt={position}
        className={`${className} rounded-xl object-cover bg-gray-800`}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = '/img/player.jpg'; // صورة احتياطية عامة
        }}
      />
      <div className={`absolute -bottom-2 left-1/2 transform -translate-x-1/2 px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-wider border shadow-sm ${styles.badgeBg}`}>
        {position}
      </div>
    </div>
  );
};

export default AnimeAvatar;